import { LSAppService } from './../../services/LSApp.service';
import { LSApiService } from './../../services/LSApi.service';
import { WindowRefService } from './../../services/WindowRef.service';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { Component, OnInit, ApplicationRef, ChangeDetectorRef, NgZone, ViewContainerRef, PLATFORM_ID, Inject } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Http } from '@angular/http';
import { ToastsManager } from 'ng2-toastr';
import { ProgressHttp } from 'angular-progress-http';
import { Lightbox } from 'angular2-lightbox';
import { isPlatformBrowser, Location } from '@angular/common';

//import * as $ from 'jquery';
declare var $:any;

@Component({
  selector: 'app-base',
  template: require('./base.component.html'),
  styles: [require('./base.component.css')]
})
export class BaseComponent implements OnInit {

  
  public busy: Subscription; // variable to hold obversable/subscription for ngBusy directive.
  public busyList: Array<Subscription>; // variable to hold obversable/subscription for ngBusy directive.
  public search = "";
  public isBrowser = false;

  public currentQueryParams:any = null;
  public currentRouteParams:any = null;

  constructor(public appRef:ApplicationRef,
    public changeDetectorRef:ChangeDetectorRef,
    public appZone: NgZone,
    public appLightbox:Lightbox,
    public loc:Location,
    public sanitizer: DomSanitizer,
    vRef: ViewContainerRef,
    public appToast:ToastsManager,
    public winRef: WindowRefService,
    public lsApi: LSApiService,
    public lsApp: LSAppService,
    public titleService: Title,
    public http: Http,
    public httpProgress: ProgressHttp,
    public router:Router,
    public route: ActivatedRoute,
    @Inject(PLATFORM_ID) public platformId: string ) {

    this.appToast.setRootViewContainerRef(vRef);
    this.isBrowser = isPlatformBrowser(platformId);
    lsApp.isUserLoggedIn();


    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
  });


   }

   public initDataTable(query:string, columnsSettings:{}[], orderColumnIndex:number = 1, pageLength:number = 50) {
    setTimeout(function(){
      if ( $.fn.dataTable.isDataTable( query ) ) {
          $(query).DataTable().destroy();
      }
      $(query).DataTable({
        pageLength: pageLength,
        order: [[ orderColumnIndex, "asc" ]],
        columns: columnsSettings
      });
    },0);
   }

   public destroyDataTable(query:string) {
    setTimeout(function(){
      if ( $.fn.dataTable.isDataTable( query ) ) {
        $(query).DataTable().destroy();
      }
    },0);
   }

   public loginRequired() {
    if(this.lsApp.isUserLoggedIn()) {
      return true;
    }
    else {
      //this.router.navigate(['/admin/login'],{queryParams:{"msg":"login required to continue.","r":this.router.url}});
      return false;
    }
   }

   public updateGivenQueryParam(key:string, value:any, queryParams:Params):Params {
    const qp: Params = Object.assign({}, queryParams);
    qp[key] = value;
    return qp; 
   }

   public updateQueryParam(key:string, value:any):Params {
     return this.updateGivenQueryParam(key,value,this.route.snapshot.queryParams);
    //const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    //queryParams[key] = value;
    //return queryParams;
   }

   public updateGivenRouteParam(key:string, value:any, params:Params):Params {
    const routeParams: Params = Object.assign({}, params);
    routeParams[key] = value;
    return routeParams;
   }

   public updateRouteParam(key:string, value:any):Params {
     return this.updateGivenRouteParam(key, value, this.route.snapshot.params);
    //const routeParams: Params = Object.assign({}, this.route.snapshot.params);
    //routeParams[key] = value;
    //return routeParams;
   }


  ngOnInit() {

    this.route.queryParams.subscribe((params: Params) => {
      this.currentQueryParams = params;
      this.queryParamsUpdated();
    });

    this.route.params.subscribe((params: Params) => {
      this.currentRouteParams = params;
      this.routeParamsUpdated();
    });



  }

  // Override this method to update UI on query params changes
  public queryParamsUpdated() { }

  // Override this method to update UI on route params changes
  public routeParamsUpdated() { }

  public default<T>(x:T, def:any):any {
    if(x==null)
      return def;
    else {
      return x;
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/base/base.component.ts